<template>
  <div>
    <h1>Novo de Cnpj</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("cnpj", ["cnpj"]),
  },
  methods: {
    ...mapActions("cnpj", ["ActionNewCnpj"]),
    loadData(id) {
      this.$router.push({ name: "cnpjs_edit", params: { id: id } });
    },
  },
  async created() {
    this.ActionNewCnpj();
  },
};
</script>

<style></style>
